import { Boxes, Building2, CirclePlus, HardHat, Network, Siren, type LucideIcon } from "lucide-react";
import { useEffect, useState } from "react";
import type { NavigationKey } from "../../app/navigation";

type CreateMenuProps = {
  onNavigate: (key: NavigationKey) => void;
};

const actions: Array<{ label: string; detail: string; destination: NavigationKey; icon: LucideIcon }> = [
  { label: "New incident", detail: "Start a controlled response", destination: "incidents", icon: Siren },
  { label: "New asset", detail: "Open asset intake", destination: "assets", icon: Boxes },
  { label: "Maintenance task", detail: "Open scheduled work", destination: "maintenance", icon: HardHat },
  { label: "Data jack", detail: "Open infrastructure records", destination: "infrastructure", icon: Network },
  { label: "Vendor outage", detail: "Open vendor operations", destination: "vendors", icon: Building2 },
];

export function CreateMenu({ onNavigate }: CreateMenuProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  return (
    <div className="dropdown-container">
      <button
        aria-expanded={open}
        className="button button--primary command-create"
        onClick={() => setOpen((current) => !current)}
        type="button"
      >
        <CirclePlus aria-hidden="true" size={18} />
        <span>Create</span>
      </button>
      {open && (
        <div className="dropdown-menu create-menu" role="menu" aria-label="Create record">
          <div className="dropdown-header"><strong>Create record</strong><small>Local demonstration</small></div>
          {actions.map(({ label, detail, destination, icon: Icon }) => (
            <button
              className="dropdown-item"
              key={label}
              onClick={() => {
                setOpen(false);
                onNavigate(destination);
              }}
              role="menuitem"
              type="button"
            >
              <Icon aria-hidden="true" size={20} />
              <span><strong>{label}</strong><small>{detail}</small></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
